.progressBar {
  background-color: var(--neutral-0);
  width: 100%;
  overflow: hidden;
  height: var(--progress-bar-height);

  .progress {
    background-color: var(--blaze-bright-yellow);
    transition: width 0.3s ease-in-out;
    height: var(--progress-bar-height);
  }
}
